import script from "./Main-SMS-Auth.vue?vue&type=script&setup=true&lang=js"
export * from "./Main-SMS-Auth.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__